import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import {makeStyles} from '@material-ui/core/styles';
import {Grid, Typography, Hidden} from '@material-ui/core';
import {Rating} from '@material-ui/lab';
import Context from 'utils/Context';
import _ from 'lodash';
import SizedeImage from 'components/SizedImage';
import Conf from 'utils/Conf';
import VODRentingButton from 'components/VODRentingButton';
import ScheduleBoard from 'components/ScheduleBoard';

// import AfficheImage from 'components/Shared/AfficheImage';

const useStyles = makeStyles(theme => ({
  text: {
    color: 'white',
    [theme.breakpoints.down('md')]: {
      fontSize: '90%',
    },
  },
}));

const FilmInfos = ({film, seancesFilm, onSeanceClick, vod, cinemaId}) => {
  const classes = useStyles();
  const {appState} = useContext(Context);
  const {t} = useTranslation();

  if (!film) return null;
  const displayRating = appState.conf.SHOW_RATING === 1;
  // const displayTitle = appState.conf.CINEMA_SHOW_FILM_TITLE;
  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <SizedeImage src={`${Conf.assetsRoot}${film.affiche}`} alt={`${film.film_name} poster`} />
      </Grid>
      <Grid item xs={8}>
        {seancesFilm.length > 0 && (
          <ScheduleBoard
            seancesByDay={Object.values(_.groupBy(seancesFilm, s => s.start_time.substring(0, 10)))}
            onSeanceClick={s => onSeanceClick(s)}
            title={t('reservez-votre-billet')}
          />
        )}
        {!!vod && <VODRentingButton vod={vod} cinemaId={cinemaId} />}
        {displayRating && film.infos_note && parseFloat(film.infos_note) > 0 && (
          <Rating name="half-rating-read" value={parseFloat(film.infos_note)} precision={0.1} readOnly />
        )}
        {film.infos_realisateur && (
          <Typography variant="body1" className={classes.text}>
            <span style={{color: 'grey'}}>
              {t('realisation')}
              &nbsp;:
            </span>
            {film.infos_realisateur}
          </Typography>
        )}
        {film.infos_casting && (
          <Typography variant="body1" className={classes.text}>
            <span style={{color: 'grey'}}>{t('avec')}&nbsp;:</span> {film.infos_casting}
          </Typography>
        )}
        <div className="spacer"></div>
        <Hidden only="xs">
          <Typography variant="body1" component="div" className={classes.text}>
            <ReactMarkdown children={film.infos_synopsis} />
          </Typography>
        </Hidden>
      </Grid>
      <Hidden smUp>
        <Grid item xs={12}>
          <Typography variant="body1" className={classes.text}>
            <Typography variant="body1" component="div" className={classes.text}>
              <ReactMarkdown children={film.infos_synopsis} />
            </Typography>
          </Typography>
        </Grid>
      </Hidden>
    </Grid>
  );
};

export default FilmInfos;
